var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('navs'),_c('lun-bo',{attrs:{"toLunBo":_vm.newData.shuffling}}),_c('Naissance'),_c('lun-bo-car'),_c('news',{attrs:{"toNews":_vm.newData.article}}),_c('foot'),_c('go-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }